document.addEventListener("alpine:init", () => {
    Alpine.data("salesPersonFilter", () => ({
        filteredResults: [],
        filteredCategories: [],
        filteredMainCategories: [],
        input: "",
        people: null,
        zips: null,
        searchEndpoint: "/api/search-contacts/{zip}/",
        isSearching: false,
        init() {
            this.people = JSON.parse(this.$refs.salesFilter.dataset.people.replace("&quot;", '"'));
            this.zips = JSON.parse(this.$refs.salesFilter.dataset.zips.replace("&quot;", '"'));
        },
        async search() {
            this.filteredResults = [];
            this.filteredCategories = [];
            this.filteredMainCategories = [];

            if (!this.input.length > 3) {
                return;
            }
            if (!this.searchEndpoint || !this.zips.some((zip) => zip.zip === this.input.trim())) {
                this.filteredResults = [];
                this.filteredCategories = [];
                return;
            }
            this.isSearching = true;
            // Search with search-endpoint
            const searchResponse = await fetch(this.searchEndpoint.replace("{zip}", this.input.trim()));
            if (searchResponse.status !== 200) {
                this.filteredResults = [];
                this.filteredCategories = [];
                return;
            }
            const searchResults = await searchResponse.json();
            Object.entries(this.people).forEach(([category, items]) => {
                items.items.forEach((person) => {
                    if (searchResults.some((result) => result.code === person.code)) {
                        this.filteredResults.push(person.code);
                        this.filteredCategories.push(category);
                    }
                });
            });
            this.isSearching = false;

            /* OPTIONALLY: ENABLE TRACKING
            window.trackingPush({
                event: "contact_search",
                search_term: this.input.trim(),
                search_results: this.filteredResults.length,
            });
             */
        },
        isSelected(id) {
            if (this.filteredResults.length || this.input.length) {
                return this.filteredResults.includes(id);
            }
            return true;
        },
        isSelectedCategory(name) {
            if (this.filteredCategories.length || this.input.length) {
                return this.filteredCategories.includes(name);
            }
            return true;
        },
        isSelectedMainCategory(name) {
            if (this.filteredMainCategories.length || this.input.length) {
                return this.filteredMainCategories.includes(name);
            }
            return true;
        },
        listZips() {
            const zips = this.zips.filter((zip) => {
                return Number(zip.zip) === Number(this.input);
            });

            return zips.map((zip) => zip.locality).join(", ");
        },
        resetInput() {
            this.input = "";
            this.filteredResults = [];
            this.filteredCategories = [];
            this.filteredMainCategories = [];
        },
    }));
});
